import { type } from "os";

export interface Role {
  id: string;
  name: string;
  description: string; // Adding this field that's referenced in the component
  pages?: any[];
}

// Create a schema representation of the interface
export const RoleSchema = {
  name: 'Role',
  nameAttribute: 'name',
  idType: 'string',
  properties: {
    id: { type: 'string' },
    name: { type: 'string' },
    description: { type: 'string' },
    pages: { type: 'string', optional: true }
  }
};
